import { Helmet } from "react-helmet-async";
import { useAuth } from "@/lib/auth";
import PayoutForm from "@/components/PayoutForm";

const NAVY = "#132a63";

export default function PortalProveedor() {
  const { user, logout } = useAuth();
  return (
    <div style={{ minHeight: "100vh", background: NAVY, padding: "24px 16px", fontFamily: "'Poppins',system-ui,sans-serif" }}>
      <Helmet><title>Portal de Proveedor — Mi Ángel Asís</title></Helmet>
      <div style={{ maxWidth: 780, margin: "0 auto" }}>
        <header style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 18, flexWrap: "wrap", gap: 10 }}>
          <div>
            <div style={{ color: "white", fontSize: 22, fontWeight: 800 }}>Hola, {user?.nombre} 👋</div>
            <div style={{ color: "#cbd5e1", fontSize: 14 }}>Proveedor de asistencias</div>
          </div>
          <button onClick={logout} data-testid="proveedor-logout" style={{ background: "rgba(255,255,255,0.12)", color: "white", border: "1px solid rgba(255,255,255,0.3)", padding: "9px 16px", borderRadius: 999, fontWeight: 700, cursor: "pointer" }}>Salir</button>
        </header>
        <div style={{ background: "white", borderRadius: 18, padding: "24px 22px" }}>
          <h3 style={{ color: NAVY, marginTop: 0 }}>Datos de tu empresa y cobro</h3>
          <PayoutForm
            getUrl="/proveedores/me/profile"
            putUrl="/proveedores/me/profile"
            docUrl="/proveedores/me/document"
            isProvider
          />
        </div>
      </div>
    </div>
  );
}
